// extracted by mini-css-extract-plugin
module.exports = {"counts":"question_counts_counts__fsCbp"};